import { NotInterested } from "@mui/icons-material";
import { Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";

const StyledDiv = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
const StyledIcon = styled(NotInterested)`
  font-size: 16rem !important;
  color: red;
`;
const StyledTitle = styled.div`
  font-size: 6rem !important;
`;
function UnauthorizedPage(): JSX.Element {
  sessionStorage.prevLocation = window.location.pathname;
  return (
    <StyledDiv>
      <StyledIcon />
      <StyledTitle>Unauthorized</StyledTitle>
      <Typography variant="h3">
        You have to be an administrator to access this resource.
      </Typography>
    </StyledDiv>
  );
}
export default UnauthorizedPage;
